import colors from '../config/theme/colors';

export default class ColorsHelper {
  public static getColor(color: any) {
    let nameColor = color;

    function getKeyByValue(object: any, value: any) {
      return Object.keys(object).find((key) => object[key] === value);
    }

    const result = getKeyByValue(colors, color);

    if (result) {
      nameColor = `var(--${result})`;
    }

    return nameColor;
  }
}
